<template>
  <div class="news-detail-page">
    <div class="page-container">
      <!-- 返回按钮 -->
      <div class="back-header">
        <button class="back-btn" @click="goBack">
          <i class="el-icon-arrow-left"></i>
          返回
        </button>
      </div>

      <!-- 加载状态 -->
      <div v-if="loading" class="loading-state">
        <div class="loading-spinner"></div>
        <p>加载中...</p>
      </div>

      <!-- 错误状态 -->
      <div v-else-if="error" class="error-state">
        <i class="el-icon-warning"></i>
        <p>{{ error }}</p>
        <button class="retry-btn" @click="fetchDetail">重新加载</button>
      </div>

      <!-- 内容区域 -->
      <div v-else-if="detail" class="detail-content">
        <div class="detail-card">
          <!-- 标题 -->
          <h1 class="detail-title">{{ detail.title }}</h1>
          
          <!-- 时间信息 -->
          <div class="detail-meta">
            <span class="meta-item">
              <i class="el-icon-time"></i>
              发布时间：{{ formatTime(detail.time) }}
            </span>
            <span class="meta-item" v-if="detail.update_time && detail.update_time !== detail.time">
              <i class="el-icon-edit"></i>
              最后修改：{{ formatTime(detail.update_time) }}
            </span>
          </div>
          
          <!-- 分割线 -->
          <div class="divider"></div>
          
          <!-- 富文本内容 -->
          <div class="detail-body" v-html="detail.content"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getNoticeDetail } from "../api/all.js"

export default {
  name: 'NewsDetail',
  data() {
    return {
      detail: null,
      loading: true,
      error: null
    }
  },
  mounted() {
    this.fetchDetail()
  },
  methods: {
    fetchDetail() {
      const id = this.$route.query.id
      if (!id) {
        this.error = '缺少文章ID'
        this.loading = false
        return
      }

      this.loading = true
      this.error = null

      getNoticeDetail({ id: id })
        .then(res => {
          if (res.status === 1) {
            this.detail = res.data
          } else {
            this.error = res.msg || '获取文章失败'
          }
          this.loading = false
        })
        .catch(err => {
          console.error('获取文章详情失败:', err)
          this.error = '网络错误，请重试'
          this.loading = false
        })
    },
    formatTime(timestamp) {
      if (!timestamp) return '-'
      const date = new Date(timestamp)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}`
    },
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped lang="less">
.news-detail-page {
  min-height: 100vh;
  background: #f5f7fa;
  padding: 20px;
}

.page-container {
  max-width: 900px;
  margin: 0 auto;
}

.back-header {
  margin-bottom: 20px;
}

.back-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 10px 20px;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  color: #4a5568;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
  
  &:hover {
    border-color: #667eea;
    color: #667eea;
    transform: translateX(-2px);
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.15);
  }
  
  i {
    font-size: 16px;
  }
}

.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 300px;
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.06);
  
  .loading-spinner {
    width: 40px;
    height: 40px;
    border: 4px solid #e2e8f0;
    border-top: 4px solid #667eea;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }
  
  p {
    margin-top: 16px;
    color: #a0aec0;
    font-size: 15px;
  }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.error-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 300px;
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.06);
  
  i {
    font-size: 48px;
    color: #e53e3e;
  }
  
  p {
    margin-top: 16px;
    color: #4a5568;
    font-size: 16px;
  }
  
  .retry-btn {
    margin-top: 20px;
    padding: 10px 32px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
    
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 16px rgba(102, 126, 234, 0.4);
    }
  }
}

.detail-card {
  background: white;
  border-radius: 16px;
  padding: 40px 50px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.06);
  
  @media (max-width: 768px) {
    padding: 24px 20px;
  }
}

.detail-title {
  font-size: 28px;
  font-weight: 700;
  color: #1a1a2e;
  margin: 0 0 16px 0;
  line-height: 1.4;
  
  @media (max-width: 768px) {
    font-size: 22px;
  }
}

.detail-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 20px;
  
  .meta-item {
    display: flex;
    align-items: center;
    gap: 6px;
    color: #a0aec0;
    font-size: 14px;
    
    i {
      font-size: 16px;
    }
  }
}

.divider {
  height: 1px;
  background: #e2e8f0;
  margin-bottom: 30px;
}

.detail-body {
  font-size: 16px;
  line-height: 1.8;
  color: #2d3748;
  
  /deep/ p {
    margin-bottom: 16px;
  }
  
  /deep/ img {
    max-width: 100%;
    height: auto;
    border-radius: 8px;
    margin: 16px 0;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  }
  
  /deep/ a {
    color: #667eea;
    text-decoration: none;
    
    &:hover {
      text-decoration: underline;
    }
  }
  
  /deep/ ul, /deep/ ol {
    padding-left: 24px;
    margin-bottom: 16px;
  }
  
  /deep/ li {
    margin-bottom: 6px;
  }
  
  /deep/ blockquote {
    border-left: 4px solid #667eea;
    padding-left: 16px;
    margin: 16px 0;
    color: #4a5568;
    background: #f7fafc;
    padding: 12px 20px;
    border-radius: 0 8px 8px 0;
  }
  
  /deep/ table {
    width: 100%;
    border-collapse: collapse;
    margin: 16px 0;
    
    th, td {
      border: 1px solid #e2e8f0;
      padding: 10px 14px;
      text-align: left;
    }
    
    th {
      background: #f7fafc;
      font-weight: 600;
    }
  }
  
  /deep/ h1, /deep/ h2, /deep/ h3, /deep/ h4 {
    margin-top: 24px;
    margin-bottom: 12px;
  }
}

@media (max-width: 768px) {
  .news-detail-page {
    padding: 12px;
  }
  
  .detail-meta {
    gap: 12px;
    
    .meta-item {
      font-size: 13px;
    }
  }
  
  .detail-body {
    font-size: 15px;
  }
}

@media (max-width: 480px) {
  .detail-title {
    font-size: 19px;
  }
  
  .detail-body {
    font-size: 14px;
  }
}
</style>